
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8S1MN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6754c08baa47708a$export$2e2bcd8739ae039; });
/* section-message.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $iQPT7 = parcelRequire("iQPT7");

var $2QYqa = parcelRequire("2QYqa");

var $iIESf = parcelRequire("iIESf");

var $j6lO9 = parcelRequire("j6lO9");

var $39c3M = parcelRequire("39c3M");

var $iskqs = parcelRequire("iskqs");
var $4Gl0I = parcelRequire("4Gl0I");

var $5dQnj = parcelRequire("5dQnj");
var $6754c08baa47708a$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    containerT26Shape: "_2rko1mok",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c8fhey _syazi7uo",
    actionsContainer: "_11c8fhey",
    dismissButtonContainer: "_1pfh1i6y"
};
var $6754c08baa47708a$var$appearanceStyles = {
    information: "_bfhk19ip",
    warning: "_bfhk1917",
    error: "_bfhk1gly",
    success: "_bfhk1y9u",
    discovery: "_bfhk6vm6"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $6754c08baa47708a$var$SectionMessage = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'information' : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, isDismissible = _ref.isDismissible, onDismiss = _ref.onDismiss, testId = _ref.testId;
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), dismissed = _useState2[0], setDismissed = _useState2[1];
    var handleDismiss = (0, $1oC0p.useCallback)(function() {
        onDismiss === null || onDismiss === void 0 || onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    var _getAppearanceIconSty = (0, $5dQnj.getAppearanceIconStyles)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, $1oC0p.Fragment) ? actions.props.children : actions;
    var actionsArray = (0, $1oC0p.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ $1oC0p.createElement("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $iQPT7.default)([
            $6754c08baa47708a$var$sectionMessageStyles.container,
            (0, $39c3M.fg)('platform-dst-shape-theme-default') && $6754c08baa47708a$var$sectionMessageStyles.containerT26Shape,
            $6754c08baa47708a$var$appearanceStyles[appearance]
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $iskqs.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $iQPT7.default)([
            $6754c08baa47708a$var$sectionMessageStyles.iconContainer
        ])
    }, /*#__PURE__*/ $1oC0p.createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ $1oC0p.createElement((0, $4Gl0I.default), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content"),
        xcss: $6754c08baa47708a$var$sectionMessageStyles.contentContainer
    }, !!title && /*#__PURE__*/ $1oC0p.createElement((0, $iIESf.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $iQPT7.default)([
            $6754c08baa47708a$var$sectionMessageStyles.content
        ])
    }, children), actionsArray.length > 0 && /*#__PURE__*/ $1oC0p.createElement((0, $iskqs.default), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xB7",
        space: "space.100",
        rowSpace: "space.0",
        role: actionsArray.length > 1 ? 'list' : undefined,
        xcss: $6754c08baa47708a$var$sectionMessageStyles.actionsContainer
    }, actionsArray.map(function(action, id) {
        return(/*#__PURE__*/ // Only use a listitem role if more than one action is present
        $1oC0p.createElement((0, $iskqs.default), {
            role: actionsArray.length > 1 ? 'listitem' : undefined,
            key: id
        }, action));
    }))), isDismissible && /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $iQPT7.default)([
            $6754c08baa47708a$var$sectionMessageStyles.dismissButtonContainer
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $2QYqa.default), {
        testId: testId && "".concat(testId, "--dismiss-button"),
        label: "Dismiss",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($j6lO9))),
        appearance: "subtle",
        onClick: handleDismiss,
        spacing: "compact"
    }))));
});
$6754c08baa47708a$var$SectionMessage.displayName = 'SectionMessage';
var $6754c08baa47708a$export$2e2bcd8739ae039 = $6754c08baa47708a$var$SectionMessage;

});
parcelRegister("iQPT7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $db955538738fcaac$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $db955538738fcaac$var$ATOMIC_GROUP_LENGTH = 5;
function $db955538738fcaac$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $db955538738fcaac$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("2QYqa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $213f4e781670c772$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $ljS5N = parcelRequire("ljS5N");

var $6dCuk = parcelRequire("6dCuk");

var $kWISO = parcelRequire("kWISO");

var $9dUVj = parcelRequire("9dUVj");

var $abrn0 = parcelRequire("abrn0");

var $3kkil = parcelRequire("3kkil");
var $213f4e781670c772$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $213f4e781670c772$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $213f4e781670c772$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, $gnQ3X.default)(_ref, $213f4e781670c772$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $gnQ3X.default)(unsafeRest, $213f4e781670c772$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9dUVj.default), (0, $c9bqK.default)({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $abrn0.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3kkil.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kWISO.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $6dCuk.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9dUVj.default), (0, $c9bqK.default)({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $ljS5N.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $abrn0.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3kkil.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kWISO.default), null, label)));
    });
}));
$213f4e781670c772$var$IconButton.displayName = 'IconButton';
var $213f4e781670c772$export$2e2bcd8739ae039 = $213f4e781670c772$var$IconButton;

});
parcelRegister("ljS5N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f85554f5c390d142$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");
function $f85554f5c390d142$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (0, $2zYm4.default)(ref) === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("6dCuk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4871cfee7f9773f2$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $1oiu1 = parcelRequire("1oiu1");

var $enrNt = parcelRequire("enrNt");

var $041L8 = parcelRequire("041L8");

var $f498p = parcelRequire("f498p");

var $6P6Jp = parcelRequire("6P6Jp");

var $01fYV = parcelRequire("01fYV");
var $b6Sy7 = parcelRequire("b6Sy7");

var $39c3M = parcelRequire("39c3M");

var $jer1f = parcelRequire("jer1f");

var $52Fo7 = parcelRequire("52Fo7");

var $3504E = parcelRequire("3504E");

var $hNPLe = parcelRequire("hNPLe");

var $iLRNK = parcelRequire("iLRNK");

var $cYEkL = parcelRequire("cYEkL");

var $1hZHP = parcelRequire("1hZHP");

var $3Dhro = parcelRequire("3Dhro");

var $iJDGz = parcelRequire("iJDGz");
function $4871cfee7f9773f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4871cfee7f9773f2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4871cfee7f9773f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4871cfee7f9773f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4871cfee7f9773f2$var$tooltipZIndex = (0, $3504E.layers).tooltip();
var $4871cfee7f9773f2$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "21.1.1"
};
// Inverts motion direction
var $4871cfee7f9773f2$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $4871cfee7f9773f2$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $4871cfee7f9773f2$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $iJDGz.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $enrNt.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $enrNt.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$UNSAFE_shouldAlw = _ref.UNSAFE_shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$UNSAFE_shouldAlw === void 0 ? false : _ref$UNSAFE_shouldAlw, _ref$UNSAFE_shouldRen = _ref.UNSAFE_shouldRenderToParent, UNSAFE_shouldRenderToParent = _ref$UNSAFE_shouldRen === void 0 ? false : _ref$UNSAFE_shouldRen;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $1oiu1.usePlatformLeafSyntheticEventHandler)($4871cfee7f9773f2$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $4871cfee7f9773f2$var$analyticsAttributes));
    var onHideHandler = (0, $1oiu1.usePlatformLeafSyntheticEventHandler)($4871cfee7f9773f2$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $4871cfee7f9773f2$var$analyticsAttributes));
    var apiRef = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)('hide'), _useState2 = (0, $2qaZZ.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $1oC0p.useRef)(null);
    var containerRef = (0, $1oC0p.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $1oC0p.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $f498p.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $f498p.default)(onShowHandler);
    var onHideHandlerStable = (0, $f498p.default)(onHideHandler);
    var delayStable = (0, $f498p.default)(delay);
    var canAppearStable = (0, $f498p.default)(canAppear);
    var hasCalledShowHandler = (0, $1oC0p.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $f498p.default)(shouldAlwaysFadeIn);
    var start = (0, $1oC0p.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $1oC0p.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(function() {
        return (0, $hNPLe.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $1oC0p.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: (0, $39c3M.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? shouldAlwaysFadeInStable.current : false
        };
        var api = (0, $1hZHP.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $041L8.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $1oC0p.useEffect)(function() {
        if (state === 'hide') return 0, $enrNt.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $dH1HR.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            // Removing old `mouse` behind gate because it stored a function.
            // With the gate we just store the coords which are easier to work with.
            mouse: (0, $39c3M.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : (0, $iLRNK.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            }),
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) {
            if (!(0, $39c3M.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) apiRef.current.mousePosition = (0, $iLRNK.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            });
            apiRef.current.mousePos = {
                clientX: event.clientX,
                clientY: event.clientY
            };
        }
    } : undefined;
    var onMouseOverTooltip = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $1oC0p.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $1oC0p.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $6P6Jp.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5, _apiRef$current6;
        if (isMousePosition && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePos && targetRef.current && (0, $39c3M.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) return (0, $cYEkL.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePosition && !(0, $39c3M.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) {
            var _apiRef$current7;
            return (_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $3Dhro.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $1oC0p.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = UNSAFE_shouldRenderToParent && (0, $39c3M.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? (0, $1oC0p.Fragment) : $4871cfee7f9773f2$var$TooltipPortal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children($4871cfee7f9773f2$var$_objectSpread($4871cfee7f9773f2$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(CastTargetContainer, (0, $c9bqK.default)({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jer1f.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = isMousePosition ? undefined : $4871cfee7f9773f2$var$invertedDirection[$4871cfee7f9773f2$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $01fYV.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $b6Sy7.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $4871cfee7f9773f2$var$_objectSpread($4871cfee7f9773f2$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $4871cfee7f9773f2$export$2e2bcd8739ae039 = $4871cfee7f9773f2$var$Tooltip;
var $4871cfee7f9773f2$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $52Fo7.default), {
        zIndex: $4871cfee7f9773f2$var$tooltipZIndex
    }, children);
};

});
parcelRegister("1oiu1", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $10365eba3a32d6de$export$1a04351537078b55; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $6zwKl = parcelRequire("6zwKl");

var $9I7IL = parcelRequire("9I7IL");
function $10365eba3a32d6de$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $10365eba3a32d6de$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $10365eba3a32d6de$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $10365eba3a32d6de$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $10365eba3a32d6de$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $6zwKl.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $9I7IL.useTrackedRef)(analyticsData);
    var fnRef = (0, $9I7IL.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $10365eba3a32d6de$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("6zwKl", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $4c8f69bd3084851f$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $lD9lj = parcelRequire("lD9lj");

var $dFMoU = parcelRequire("dFMoU");
function $4c8f69bd3084851f$export$5bf35293e545f20c() {
    var analyticsContext = (0, $dFMoU.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $lD9lj.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("lD9lj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fbf47cc31cb94078$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $gIw5a = parcelRequire("gIw5a");
function $fbf47cc31cb94078$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $fbf47cc31cb94078$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $fbf47cc31cb94078$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fbf47cc31cb94078$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $fbf47cc31cb94078$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $fbf47cc31cb94078$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $fbf47cc31cb94078$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $fbf47cc31cb94078$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cTewU.default)(this, UIAnalyticsEvent);
        _this = $fbf47cc31cb94078$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $f53LC.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $f53LC.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lFOXD.default)(_this.context);
            var handlers = (0, $lFOXD.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $f53LC.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $i7dvh.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $avOEA.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $fbf47cc31cb94078$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $gIw5a.default));

});
parcelRegister("gIw5a", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c2b9a44875f646e2$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
function $c2b9a44875f646e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2b9a44875f646e2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2b9a44875f646e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2b9a44875f646e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c2b9a44875f646e2$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c2b9a44875f646e2$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $c2b9a44875f646e2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cTewU.default)(this, AnalyticsEvent);
        (0, $f53LC.default)(this, "_isAnalyticsEvent", true);
        (0, $f53LC.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $c2b9a44875f646e2$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $avOEA.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $2zYm4.default)(updater) === 'object') this.payload = $c2b9a44875f646e2$var$_objectSpread($c2b9a44875f646e2$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("dFMoU", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $9f44a611b337ecd4$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $9f44a611b337ecd4$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("9I7IL", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $711e365c15ea05d0$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $711e365c15ea05d0$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("enrNt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a778c696b1faf6b7$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $a778c696b1faf6b7$export$2e2bcd8739ae039() {}

});

parcelRegister("041L8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $00c1bd3090e3e108$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $ljKW0 = parcelRequire("ljKW0");
function $00c1bd3090e3e108$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1oC0p.useRef)(false);
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $ljKW0.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $1oC0p.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1oC0p.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $dH1HR.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("ljKW0", function(module, exports) {
$parcel$export(module.exports, "ESCAPE", function () { return $04014969797669f9$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $04014969797669f9$export$390330c10ff2b9a1 = 'ArrowUp';
var $04014969797669f9$export$a80636c6f41931fe = 'ArrowDown';
var $04014969797669f9$export$fc4577f2a2af0ae3 = 'ArrowLeft';
var $04014969797669f9$export$c40f9845adc73fb5 = 'ArrowRight';
var $04014969797669f9$export$4af703091671bc = 'Home';
var $04014969797669f9$export$e2bc30913faa5db7 = 'End';
var $04014969797669f9$export$10f6869ed0a7d75b = 'Tab';
var $04014969797669f9$export$8152f929a25a0ff4 = 'Enter';
var $04014969797669f9$export$e51a3576c045c8d5 = 'Space';
var $04014969797669f9$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("f498p", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af7e50afeb3172fd$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $af7e50afeb3172fd$export$2e2bcd8739ae039(value) {
    var ref = (0, $1oC0p.useRef)(value);
    (0, $1oC0p.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("3504E", function(module, exports) {
$parcel$export(module.exports, "layers", function () { return $23e1e56800889f59$export$7be255094ccdc533; });

var $fWW8x = parcelRequire("fWW8x");

var $dJQA9 = parcelRequire("dJQA9");
var $23e1e56800889f59$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $23e1e56800889f59$export$c93026a968943f95 = 'light';
var $23e1e56800889f59$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $23e1e56800889f59$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $dJQA9.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $fWW8x.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $23e1e56800889f59$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $23e1e56800889f59$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $23e1e56800889f59$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $fWW8x.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $23e1e56800889f59$export$ba1d834b86d72a09 = $23e1e56800889f59$export$a1b3edb637fb4f35;
var $23e1e56800889f59$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $dJQA9.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $dJQA9.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $dJQA9.N30A), ")")
            }
        }
    };
};

});
parcelRegister("fWW8x", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b9c95e836e23b1ec$export$2e2bcd8739ae039; });

var $8aIWG = parcelRequire("8aIWG");

var $7t0tI = parcelRequire("7t0tI");
function $b9c95e836e23b1ec$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $8aIWG.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $b9c95e836e23b1ec$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("8aIWG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5f321f1e0c76d01f$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $5f321f1e0c76d01f$var$printed = {};
function $5f321f1e0c76d01f$export$2e2bcd8739ae039(message) {
    if ($5f321f1e0c76d01f$var$printed[message]) return;
    $5f321f1e0c76d01f$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("dJQA9", function(module, exports) {
$parcel$export(module.exports, "B200", function () { return $a008440d6e56e926$export$215b7063051591f1; });
$parcel$export(module.exports, "N20A", function () { return $a008440d6e56e926$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $a008440d6e56e926$export$920c0d5c49070351; });
// Reds
var $a008440d6e56e926$export$4b84fd0e2c617bd = '#FFEBE6';
var $a008440d6e56e926$export$b34b069eff244586 = '#FFBDAD';
var $a008440d6e56e926$export$be802dd0d8b57f35 = '#FF8F73';
var $a008440d6e56e926$export$60847d42f9da92a6 = '#FF7452';
var $a008440d6e56e926$export$4a7404f376229999 = '#FF5630';
var $a008440d6e56e926$export$2010d0fb4295b346 = '#DE350B';
var $a008440d6e56e926$export$2837b5a1a71d5c02 = '#BF2600';
var $a008440d6e56e926$export$8d9596b529bbb9cf = '#FFFAE6';
var $a008440d6e56e926$export$41060a744ab0b7ae = '#FFF0B3';
var $a008440d6e56e926$export$1cc05bbbf340e559 = '#FFE380';
var $a008440d6e56e926$export$5aae31392d72caaa = '#FFC400';
var $a008440d6e56e926$export$c6930421db9fa514 = '#FFAB00';
var $a008440d6e56e926$export$59619663aa6500fb = '#FF991F';
var $a008440d6e56e926$export$874739ea9e379ab6 = '#FF8B00';
var $a008440d6e56e926$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $a008440d6e56e926$export$69a3bf21b9686c2b = '#ABF5D1';
var $a008440d6e56e926$export$afbce1382ec95f73 = '#79F2C0';
var $a008440d6e56e926$export$747d86715d4175de = '#57D9A3';
var $a008440d6e56e926$export$940e1f69e873f202 = '#36B37E';
var $a008440d6e56e926$export$a49394138f7b8e85 = '#00875A';
var $a008440d6e56e926$export$6fa04827ac68a4fb = '#006644';
var $a008440d6e56e926$export$226de0355ed012f8 = '#DEEBFF';
var $a008440d6e56e926$export$8c13c2ee36917869 = '#B3D4FF';
var $a008440d6e56e926$export$ecfc1dff386a3e7a = '#4C9AFF';
var $a008440d6e56e926$export$215b7063051591f1 = '#2684FF';
var $a008440d6e56e926$export$e62e8919cca44969 = '#0065FF';
var $a008440d6e56e926$export$b3de0ae08da2ce64 = '#0052CC';
var $a008440d6e56e926$export$a6ee3d71bc067634 = '#0747A6';
var $a008440d6e56e926$export$67f15409e87642a1 = '#669DF1';
var $a008440d6e56e926$export$f0539dbc42dbb067 = '#8FB8F6';
var $a008440d6e56e926$export$363e4475840015bb = '#EAE6FF';
var $a008440d6e56e926$export$4b0a4417ed59760f = '#C0B6F2';
var $a008440d6e56e926$export$6011520a64d9a187 = '#998DD9';
var $a008440d6e56e926$export$a7175d4e9206bc80 = '#8777D9';
var $a008440d6e56e926$export$b48405b95304b5a1 = '#6554C0';
var $a008440d6e56e926$export$c71e4279dd54a18d = '#5243AA';
var $a008440d6e56e926$export$147899de772240ec = '#403294';
var $a008440d6e56e926$export$2cf711fe14c66f06 = '#E6FCFF';
var $a008440d6e56e926$export$7a8f4d33f6f9772c = '#B3F5FF';
var $a008440d6e56e926$export$776c9c497ef08533 = '#79E2F2';
var $a008440d6e56e926$export$69cb3ca10c1e330e = '#00C7E6';
var $a008440d6e56e926$export$9dc1ef0f3f48059b = '#00B8D9';
var $a008440d6e56e926$export$7c835c78b6fcdef8 = '#00A3BF';
var $a008440d6e56e926$export$6036577f95c3877e = '#008DA6';
var $a008440d6e56e926$export$29a4f05edc054374 = '#FFFFFF';
var $a008440d6e56e926$export$e655ef011c4aa1a2 = '#FAFBFC';
var $a008440d6e56e926$export$9fdfb749e33cdf97 = '#F4F5F7';
var $a008440d6e56e926$export$3e51e8f1440314ba = '#EBECF0';
var $a008440d6e56e926$export$1ce2d1575d444ceb = '#DFE1E6';
var $a008440d6e56e926$export$8754fc7e6d8b3000 = '#C1C7D0';
var $a008440d6e56e926$export$c2e91cbeada39b8b = '#B3BAC5';
var $a008440d6e56e926$export$5f71e19f3a7ad9de = '#A5ADBA';
var $a008440d6e56e926$export$eaa8c8a70ac22806 = '#97A0AF';
var $a008440d6e56e926$export$7c87d337fb91a97d = '#8993A4';
var $a008440d6e56e926$export$d6447c357493214f = '#7A869A';
var $a008440d6e56e926$export$f563ee71e9ee74cd = '#6B778C';
var $a008440d6e56e926$export$e2ef2124cf4024b1 = '#5E6C84';
var $a008440d6e56e926$export$eece5f492e429f08 = '#505F79';
var $a008440d6e56e926$export$c39c0fe0f26207ae = '#42526E';
var $a008440d6e56e926$export$7090862dc3038a9f = '#344563';
var $a008440d6e56e926$export$ad0bacf983b7ddaa = '#253858';
var $a008440d6e56e926$export$7d61b15e0da132af = '#172B4D';
var $a008440d6e56e926$export$fbda843f0a27fe96 = '#091E42';
var $a008440d6e56e926$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $a008440d6e56e926$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $a008440d6e56e926$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $a008440d6e56e926$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $a008440d6e56e926$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $a008440d6e56e926$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $a008440d6e56e926$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $a008440d6e56e926$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $a008440d6e56e926$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $a008440d6e56e926$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $a008440d6e56e926$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $a008440d6e56e926$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $a008440d6e56e926$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $a008440d6e56e926$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $a008440d6e56e926$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $a008440d6e56e926$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $a008440d6e56e926$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $a008440d6e56e926$export$2f6319cf7d736c2a = '#E6EDFA';
var $a008440d6e56e926$export$95126bc8884d6634 = '#DCE5F5';
var $a008440d6e56e926$export$8338d8c35d44ff1 = '#CED9EB';
var $a008440d6e56e926$export$5368d76ae4fbbda7 = '#B8C7E0';
var $a008440d6e56e926$export$9f0a771d16ec8d36 = '#ABBBD6';
var $a008440d6e56e926$export$abcf8c38338b4aa5 = '#9FB0CC';
var $a008440d6e56e926$export$97e81faa16a182c7 = '#8C9CB8';
var $a008440d6e56e926$export$bfe21c59123ecf33 = '#7988A3';
var $a008440d6e56e926$export$ee82aa2ea6a1558 = '#67758F';
var $a008440d6e56e926$export$682927c6ed76be02 = '#56637A';
var $a008440d6e56e926$export$91fd9994c5be9757 = '#455166';
var $a008440d6e56e926$export$d281fbfe3cff2df6 = '#3B475C';
var $a008440d6e56e926$export$3902c91d8b98a753 = '#313D52';
var $a008440d6e56e926$export$8e8133c1ba5845b5 = '#283447';
var $a008440d6e56e926$export$33ff357f6620b39 = '#202B3D';
var $a008440d6e56e926$export$633847cf062b69e0 = '#1B2638';
var $a008440d6e56e926$export$9776a6e503bdbf76 = '#121A29';
var $a008440d6e56e926$export$6c813d5160dff5db = '#0E1624';
var $a008440d6e56e926$export$3d4f271a500072a = '#0D1424';
var $a008440d6e56e926$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $a008440d6e56e926$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $a008440d6e56e926$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $a008440d6e56e926$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $a008440d6e56e926$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $a008440d6e56e926$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $a008440d6e56e926$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $a008440d6e56e926$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $a008440d6e56e926$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $a008440d6e56e926$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $a008440d6e56e926$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $a008440d6e56e926$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $a008440d6e56e926$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $a008440d6e56e926$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $a008440d6e56e926$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $a008440d6e56e926$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $a008440d6e56e926$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $a008440d6e56e926$export$d2adc5dedf09fced = '#292A2E';
var $a008440d6e56e926$export$f51762073d2bb381 = '#94C748';
var $a008440d6e56e926$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("hNPLe", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cf5f29e3a9ad9300$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $dH1HR = parcelRequire("dH1HR");
var $cf5f29e3a9ad9300$var$registrations = new Set();
var $cf5f29e3a9ad9300$var$cleanupEndEventListeners = null;
function $cf5f29e3a9ad9300$var$onDragStart() {
    if ($cf5f29e3a9ad9300$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $cf5f29e3a9ad9300$var$cleanupEndEventListeners = (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragend',
            listener: $cf5f29e3a9ad9300$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $cf5f29e3a9ad9300$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $cf5f29e3a9ad9300$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($cf5f29e3a9ad9300$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $cf5f29e3a9ad9300$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $cf5f29e3a9ad9300$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $cf5f29e3a9ad9300$var$cleanupEndEventListeners = null;
    var clone = Array.from($cf5f29e3a9ad9300$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $cf5f29e3a9ad9300$var$bindStartEvents() {
    return (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $cf5f29e3a9ad9300$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $cf5f29e3a9ad9300$var$onDragStart
        }
    ]);
}
var $cf5f29e3a9ad9300$var$cleanupStartEventListeners = null;
function $cf5f29e3a9ad9300$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$cf5f29e3a9ad9300$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $cf5f29e3a9ad9300$var$cleanupStartEventListeners = $cf5f29e3a9ad9300$var$bindStartEvents();
    $cf5f29e3a9ad9300$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $cf5f29e3a9ad9300$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $cf5f29e3a9ad9300$var$registrations.delete(registration);
        if ($cf5f29e3a9ad9300$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $cf5f29e3a9ad9300$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $cf5f29e3a9ad9300$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("iLRNK", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", function () { return $daa6599ce83a1163$export$642213d516a9b928; });
function $daa6599ce83a1163$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});

parcelRegister("cYEkL", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", function () { return $972a60180ae4d446$export$2e68479e0a5d8746; });
function $972a60180ae4d446$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}

});

parcelRegister("1hZHP", function(module, exports) {
$parcel$export(module.exports, "show", function () { return $0f073e81a5f4c3ca$export$57bf213be019eeb0; });

var $39c3M = parcelRequire("39c3M");

var $jB0P3 = parcelRequire("jB0P3");
// This file is a singleton for managing tooltips
var $0f073e81a5f4c3ca$var$active = null;
function $0f073e81a5f4c3ca$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($0f073e81a5f4c3ca$var$active && $0f073e81a5f4c3ca$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $jB0P3.clearScheduled)();
            $0f073e81a5f4c3ca$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $jB0P3.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $jB0P3.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $jB0P3.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var shouldAlwaysFadeIn = (0, $39c3M.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? entry.shouldAlwaysFadeIn : false;
        var showImmediately = Boolean($0f073e81a5f4c3ca$var$active && $0f073e81a5f4c3ca$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($0f073e81a5f4c3ca$var$active) {
            (0, $jB0P3.clearScheduled)();
            $0f073e81a5f4c3ca$var$active.entry.hide({
                isImmediate: true
            });
            $0f073e81a5f4c3ca$var$active.entry.done();
            $0f073e81a5f4c3ca$var$active = null;
        }
        // this tooltip is now the active tooltip
        $0f073e81a5f4c3ca$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $jB0P3.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        // Removing old `mousePosition` behind gate because it stored a function.
        // With the gate we just store the coords which are easier to work with.
        mousePosition: (0, $39c3M.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : getInitialMouse(),
        mousePos: entry.source.type === 'mouse' && (0, $39c3M.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});
parcelRegister("jB0P3", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", function () { return $e4421c5a8da84bd5$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $e4421c5a8da84bd5$export$5f4d6617421d489b; });
var $e4421c5a8da84bd5$var$delayId = null;
function $e4421c5a8da84bd5$export$eaf678f6f93f5250() {
    if ($e4421c5a8da84bd5$var$delayId != null) {
        window.clearTimeout($e4421c5a8da84bd5$var$delayId);
        $e4421c5a8da84bd5$var$delayId = null;
    }
}
function $e4421c5a8da84bd5$export$5f4d6617421d489b(fn, delay) {
    $e4421c5a8da84bd5$export$eaf678f6f93f5250();
    $e4421c5a8da84bd5$var$delayId = window.setTimeout(function() {
        $e4421c5a8da84bd5$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("3Dhro", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2a528afbac9a8cf4$export$2e2bcd8739ae039; });

var $1tU4W = parcelRequire("1tU4W");
function $2a528afbac9a8cf4$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $1tU4W.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("1tU4W", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", function () { return $1143ffeb08ec8a24$export$6ee17796e3d70de2; });

var $2zYm4 = parcelRequire("2zYm4");

var $1oC0p = parcelRequire("1oC0p");
function $1143ffeb08ec8a24$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId().replace(/[:«»]/g, '_');
}
var $1143ffeb08ec8a24$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($1143ffeb08ec8a24$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $2zYm4.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $2zYm4.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $1143ffeb08ec8a24$export$6ee17796e3d70de2() {
    var uid = $1143ffeb08ec8a24$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}

});


parcelRegister("iJDGz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $da3b36b0ee3bed62$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $iQPT7 = parcelRequire("iQPT7");

var $4fv7N = parcelRequire("4fv7N");
var $da3b36b0ee3bed62$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $da3b36b0ee3bed62$var$TooltipContainer = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $1oC0p.createElement((0, $4fv7N.default), {
        ref: ref,
        style: style,
        className: (0, $iQPT7.default)([
            $da3b36b0ee3bed62$var$styles.base,
            truncate && $da3b36b0ee3bed62$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$da3b36b0ee3bed62$var$TooltipContainer.displayName = 'TooltipContainer';
var $da3b36b0ee3bed62$export$2e2bcd8739ae039 = $da3b36b0ee3bed62$var$TooltipContainer;

});
parcelRegister("4fv7N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3180b4df0ff2a900$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $iQPT7 = parcelRequire("iQPT7");

var $cYmet = parcelRequire("cYmet");
var $3180b4df0ff2a900$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $3180b4df0ff2a900$var$TooltipPrimitive = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        role: "tooltip",
        className: (0, $iQPT7.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $1oC0p.createElement((0, $cYmet.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$3180b4df0ff2a900$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $3180b4df0ff2a900$export$2e2bcd8739ae039 = $3180b4df0ff2a900$var$TooltipPrimitive;

});
parcelRegister("cYmet", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", function () { return $971c5589182411a0$export$5bcbc43c84236222; });
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $iQPT7 = parcelRequire("iQPT7");
var $971c5589182411a0$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $971c5589182411a0$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $iQPT7.default)([
            $971c5589182411a0$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $1oC0p.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $iQPT7.default)([
                $971c5589182411a0$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};

});




parcelRegister("kWISO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f3fc0a4740501b66$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $1oC0p = parcelRequire("1oC0p");

var $2xhwp = parcelRequire("2xhwp");
var $f3fc0a4740501b66$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $f3fc0a4740501b66$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $2xhwp.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $f3fc0a4740501b66$export$2e2bcd8739ae039 = $f3fc0a4740501b66$var$VisuallyHidden;

});
parcelRegister("2xhwp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1d8c4145fa3c57e8$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $1d8c4145fa3c57e8$var$ATOMIC_GROUP_LENGTH = 5;
function $1d8c4145fa3c57e8$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $1d8c4145fa3c57e8$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});


parcelRegister("9dUVj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6b717bbaa8ab32ac$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $iQPT7 = parcelRequire("iQPT7");

var $1oC0p = parcelRequire("1oC0p");

var $4u8cT = parcelRequire("4u8cT");

var $ljS5N = parcelRequire("ljS5N");

var $bBcpX = parcelRequire("bBcpX");

var $3W1hP = parcelRequire("3W1hP");

var $39c3M = parcelRequire("39c3M");

var $1oli1 = parcelRequire("1oli1");

var $kWISO = parcelRequire("kWISO");

var $e3ezC = parcelRequire("e3ezC");

var $5dWm2 = parcelRequire("5dWm2");

var $fCSw9 = parcelRequire("fCSw9");
var $6b717bbaa8ab32ac$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $6b717bbaa8ab32ac$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $6b717bbaa8ab32ac$var$LOADING_LABEL = ', Loading';
var $6b717bbaa8ab32ac$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $6b717bbaa8ab32ac$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $6b717bbaa8ab32ac$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $6b717bbaa8ab32ac$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $6b717bbaa8ab32ac$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $6b717bbaa8ab32ac$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $6b717bbaa8ab32ac$var$subtleStyles = {
    root: "_bfhkqtfy _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr34mfv _30l3azsu _1di619qy _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $6b717bbaa8ab32ac$var$selectedStyles = {
    root: "_bfhk15s3 _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $6b717bbaa8ab32ac$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, $gnQ3X.default)(_ref, $6b717bbaa8ab32ac$var$_excluded);
    var localRef = (0, $1oC0p.useRef)(null);
    var splitButtonContext = (0, $e3ezC.useSplitButtonContext)();
    var loadingLabelId = (0, $3W1hP.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $bBcpX.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $gnQ3X.default)(unsafeRest, $6b717bbaa8ab32ac$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oli1.default), (0, $c9bqK.default)({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $ljS5N.default)([
            localRef,
            ref
        ]),
        xcss: (0, $4u8cT.cx)($6b717bbaa8ab32ac$var$styles.base, (0, $39c3M.fg)('platform-dst-shape-theme-default') && $6b717bbaa8ab32ac$var$styles.baseT26Shape, appearance === 'default' && $6b717bbaa8ab32ac$var$defaultStyles.root, appearance === 'default' && isInteractive && $6b717bbaa8ab32ac$var$defaultStyles.interactive, appearance === 'primary' && $6b717bbaa8ab32ac$var$primaryStyles.root, appearance === 'primary' && isInteractive && $6b717bbaa8ab32ac$var$primaryStyles.interactive, appearance === 'warning' && $6b717bbaa8ab32ac$var$warningStyles.root, appearance === 'warning' && isInteractive && $6b717bbaa8ab32ac$var$warningStyles.interactive, appearance === 'danger' && $6b717bbaa8ab32ac$var$dangerStyles.root, appearance === 'danger' && isInteractive && $6b717bbaa8ab32ac$var$dangerStyles.interactive, appearance === 'discovery' && $6b717bbaa8ab32ac$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $6b717bbaa8ab32ac$var$discoveryStyles.interactive, appearance === 'subtle' && $6b717bbaa8ab32ac$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $6b717bbaa8ab32ac$var$subtleStyles.interactive, $6b717bbaa8ab32ac$var$styles.linkDecorationUnset, isSelected && $6b717bbaa8ab32ac$var$selectedStyles.root, isSelected && isSplitButton && $6b717bbaa8ab32ac$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $6b717bbaa8ab32ac$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $6b717bbaa8ab32ac$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $6b717bbaa8ab32ac$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $6b717bbaa8ab32ac$var$selectedStyles.discovery, isDisabled && $6b717bbaa8ab32ac$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $6b717bbaa8ab32ac$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $6b717bbaa8ab32ac$var$defaultStyles.disabled, isCircle && !isSplitButton && $6b717bbaa8ab32ac$var$styles.circle, spacing === 'compact' && $6b717bbaa8ab32ac$var$styles.spacingCompact, spacing === 'compact' && (0, $39c3M.fg)('platform-dst-shape-theme-default') && $6b717bbaa8ab32ac$var$styles.spacingCompactT26Shape, shouldFitContainer && $6b717bbaa8ab32ac$var$styles.fullWidth, hasIconBefore && $6b717bbaa8ab32ac$var$styles.buttonIconBefore, hasIconAfter && $6b717bbaa8ab32ac$var$styles.buttonIconAfter, isIconButton && $6b717bbaa8ab32ac$var$styles.iconButton, isIconButton && spacing === 'compact' && $6b717bbaa8ab32ac$var$styles.iconButtonCompact, isLoading && $6b717bbaa8ab32ac$var$styles.loading, isSplitButton && $6b717bbaa8ab32ac$var$styles.splitButton, isNavigationSplitButton && $6b717bbaa8ab32ac$var$styles.navigationSplitButton),
        isDisabled: (0, $39c3M.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }, (0, $39c3M.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, $39c3M.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($6b717bbaa8ab32ac$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $5dWm2.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $e3ezC.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        className: (0, $iQPT7.default)([
            $6b717bbaa8ab32ac$var$styles.loadingOverlay
        ])
    }, (0, $fCSw9.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kWISO.default), {
        id: loadingLabelId
    }, $6b717bbaa8ab32ac$var$LOADING_LABEL)));
});
var $6b717bbaa8ab32ac$export$2e2bcd8739ae039 = $6b717bbaa8ab32ac$var$ButtonBase;

});
parcelRegister("4u8cT", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $344054809df0a9cb$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("1oC0p");


var $eH5ou = parcelRequire("eH5ou");
var $344054809df0a9cb$var$strictApi = (0, $eH5ou.createStrictAPI)();
var $344054809df0a9cb$export$dbf350e5966cf602 = $344054809df0a9cb$var$strictApi.css;
var $344054809df0a9cb$export$eb1ecd84a24ee424 = $344054809df0a9cb$var$strictApi.cssMap;
$344054809df0a9cb$var$strictApi.cssMap;
var $344054809df0a9cb$export$a274e22fb40f762e = $344054809df0a9cb$var$strictApi.cx;
var $344054809df0a9cb$var$XCSSProp = $344054809df0a9cb$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});
parcelRegister("eH5ou", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", function () { return $ab2943f70ef8859e$export$39716b4af53f4ad; });

var $8npm8 = parcelRequire("8npm8");

var $l9TkK = parcelRequire("l9TkK");
function $ab2943f70ef8859e$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $8npm8.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $8npm8.createStrictSetupError)();
        },
        cx: $l9TkK.cx,
        XCSSProp () {
            throw (0, $8npm8.createStrictSetupError)();
        }
    };
}

});
parcelRegister("8npm8", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", function () { return $619423e9a4495177$export$c4df1cb0c2b4d77c; });
const $619423e9a4495177$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $619423e9a4495177$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("l9TkK", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $f6755c5ccb2bc5f9$export$a274e22fb40f762e; });

var $dmpcl = parcelRequire("dmpcl");
const $f6755c5ccb2bc5f9$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $dmpcl.default)(actualStyles);
};

});
parcelRegister("dmpcl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9ba0e040259b4cf1$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $9ba0e040259b4cf1$var$ATOMIC_GROUP_LENGTH = 5;
function $9ba0e040259b4cf1$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $9ba0e040259b4cf1$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("bBcpX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $022de232d4f56fe9$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $022de232d4f56fe9$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("3W1hP", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $2dd7c95c9e02240c$export$f680877a34711e37; });

var $2zYm4 = parcelRequire("2zYm4");

var $1oC0p = parcelRequire("1oC0p");
function $2dd7c95c9e02240c$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId().replace(/[:«»]/g, '_');
}
var $2dd7c95c9e02240c$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($2dd7c95c9e02240c$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $2zYm4.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $2zYm4.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $2dd7c95c9e02240c$export$6ee17796e3d70de2() {
    var uid = $2dd7c95c9e02240c$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}

});

parcelRegister("1oli1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $10388c01ef715a2b$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");


var $cL3af = parcelRequire("cL3af");

var $gEChp = parcelRequire("gEChp");

var $9MvDX = parcelRequire("9MvDX");

var $5F79F = parcelRequire("5F79F");

var $etBkE = parcelRequire("etBkE");

var $4YLi4 = parcelRequire("4YLi4");
var $10388c01ef715a2b$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $10388c01ef715a2b$var$_excluded2 = [
    "className"
];
var $10388c01ef715a2b$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $10388c01ef715a2b$var$Pressable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $5F79F.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $gnQ3X.default)(_ref, $10388c01ef715a2b$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $etBkE.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $gEChp.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $10388c01ef715a2b$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement((0, $4YLi4.default), (0, $c9bqK.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $9MvDX.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $cL3af.cx)($10388c01ef715a2b$var$styles.root, isDisabled && $10388c01ef715a2b$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $10388c01ef715a2b$export$2e2bcd8739ae039 = $10388c01ef715a2b$var$Pressable;

});
parcelRegister("cL3af", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $949c5434d31dfd22$export$a274e22fb40f762e; });

var $iQPT7 = parcelRequire("iQPT7");
const $949c5434d31dfd22$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $iQPT7.default)(actualStyles);
};

});

parcelRegister("gEChp", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $c1fe13540c0c6df3$export$a4687b0234b40e28; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $6zwKl = parcelRequire("6zwKl");

var $9I7IL = parcelRequire("9I7IL");
function $c1fe13540c0c6df3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c1fe13540c0c6df3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c1fe13540c0c6df3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c1fe13540c0c6df3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c1fe13540c0c6df3$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $6zwKl.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $9I7IL.useTrackedRef)(analyticsData);
    var fnRef = (0, $9I7IL.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $c1fe13540c0c6df3$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("9MvDX", function(module, exports) {
$parcel$export(module.exports, "isSafari", function () { return $71f124812e283a54$export$95df08bae54cb4df; });
function $71f124812e283a54$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $71f124812e283a54$var$isIPhone() {
    return $71f124812e283a54$var$testPlatform(/^iPhone/i);
}
function $71f124812e283a54$var$isMac() {
    return $71f124812e283a54$var$testPlatform(/^Mac/i);
}
function $71f124812e283a54$var$isIPad() {
    return $71f124812e283a54$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $71f124812e283a54$var$isMac() && navigator.maxTouchPoints > 1;
}
function $71f124812e283a54$var$isIOS() {
    return $71f124812e283a54$var$isIPhone() || $71f124812e283a54$var$isIPad();
}
function $71f124812e283a54$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $71f124812e283a54$export$e1865c3bedcd822b() {
    return $71f124812e283a54$var$isMac() || $71f124812e283a54$var$isIOS();
}

});

parcelRegister("5F79F", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $41f654e88947f963$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $41f654e88947f963$export$2e2bcd8739ae039() {}

});

parcelRegister("4YLi4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3a0172ec76b4eefb$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $iQPT7 = parcelRequire("iQPT7");
var $3a0172ec76b4eefb$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $3a0172ec76b4eefb$var$_excluded2 = [
    "className"
];
var $3a0172ec76b4eefb$var$focusRingStyles = null;
var $3a0172ec76b4eefb$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $3a0172ec76b4eefb$var$Focusable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $3a0172ec76b4eefb$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $3a0172ec76b4eefb$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $iQPT7.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $3a0172ec76b4eefb$export$2e2bcd8739ae039 = $3a0172ec76b4eefb$var$Focusable;

});


parcelRegister("e3ezC", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", function () { return $a3aca679dc031212$export$4b86304b2c0d7e71; });
$parcel$export(module.exports, "useSplitButtonContext", function () { return $a3aca679dc031212$export$47e2c6fdb142d947; });

var $1oC0p = parcelRequire("1oC0p");
var $a3aca679dc031212$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $a3aca679dc031212$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $1oC0p.useContext)($a3aca679dc031212$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("5dWm2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3cdb6ea3832f91f2$export$2e2bcd8739ae039; });
function $3cdb6ea3832f91f2$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $3cdb6ea3832f91f2$var$tabKeyCode = 9;
function $3cdb6ea3832f91f2$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $3cdb6ea3832f91f2$var$tabKeyCode) return;
    $3cdb6ea3832f91f2$var$abort(event);
}
function $3cdb6ea3832f91f2$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $3cdb6ea3832f91f2$var$abort,
        onMouseUpCapture: $3cdb6ea3832f91f2$var$abort,
        onKeyDownCapture: $3cdb6ea3832f91f2$var$onKey,
        onKeyUpCapture: $3cdb6ea3832f91f2$var$onKey,
        onTouchStartCapture: $3cdb6ea3832f91f2$var$abort,
        onTouchEndCapture: $3cdb6ea3832f91f2$var$abort,
        onPointerDownCapture: $3cdb6ea3832f91f2$var$abort,
        onPointerUpCapture: $3cdb6ea3832f91f2$var$abort,
        onClickCapture: $3cdb6ea3832f91f2$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $3cdb6ea3832f91f2$var$abort
    } : events;
}

});

parcelRegister("fCSw9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b604b1b259e11532$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $b3RuC = parcelRequire("b3RuC");
function $b604b1b259e11532$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $b604b1b259e11532$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $b604b1b259e11532$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $b3RuC.default), {
        size: $b604b1b259e11532$var$getIconSpacing(spacing),
        appearance: $b604b1b259e11532$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("b3RuC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $80d978189bf1d955$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $6RzqY = parcelRequire("6RzqY");

var $1oC0p = parcelRequire("1oC0p");

var $etBkE = parcelRequire("etBkE");

var $7PaAm = parcelRequire("7PaAm");

var $7YPJK = parcelRequire("7YPJK");
/**
 * Returns the appropriate circle stroke color.
 */ function $80d978189bf1d955$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $7PaAm.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $7PaAm.N0), ")");
}
var $80d978189bf1d955$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $80d978189bf1d955$var$loadIn = null;
var $80d978189bf1d955$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $80d978189bf1d955$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $80d978189bf1d955$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $7YPJK.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $80d978189bf1d955$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $etBkE.default));
    $80d978189bf1d955$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $6RzqY.default)([
            $80d978189bf1d955$var$styles.wrapperStyles,
            $80d978189bf1d955$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $6RzqY.default)([
            $80d978189bf1d955$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $6RzqY.default)([
            $80d978189bf1d955$var$styles.circleStyles
        ])
    })));
}));
var $80d978189bf1d955$export$2e2bcd8739ae039 = $80d978189bf1d955$var$Spinner;

});
parcelRegister("6RzqY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4ff32dcb50eff4c6$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $4ff32dcb50eff4c6$var$ATOMIC_GROUP_LENGTH = 5;
function $4ff32dcb50eff4c6$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $4ff32dcb50eff4c6$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("7PaAm", function(module, exports) {
$parcel$export(module.exports, "N0", function () { return $5b2581db7ad95401$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $5b2581db7ad95401$export$c39c0fe0f26207ae; });
// Reds
var $5b2581db7ad95401$export$4b84fd0e2c617bd = '#FFEBE6';
var $5b2581db7ad95401$export$b34b069eff244586 = '#FFBDAD';
var $5b2581db7ad95401$export$be802dd0d8b57f35 = '#FF8F73';
var $5b2581db7ad95401$export$60847d42f9da92a6 = '#FF7452';
var $5b2581db7ad95401$export$4a7404f376229999 = '#FF5630';
var $5b2581db7ad95401$export$2010d0fb4295b346 = '#DE350B';
var $5b2581db7ad95401$export$2837b5a1a71d5c02 = '#BF2600';
var $5b2581db7ad95401$export$8d9596b529bbb9cf = '#FFFAE6';
var $5b2581db7ad95401$export$41060a744ab0b7ae = '#FFF0B3';
var $5b2581db7ad95401$export$1cc05bbbf340e559 = '#FFE380';
var $5b2581db7ad95401$export$5aae31392d72caaa = '#FFC400';
var $5b2581db7ad95401$export$c6930421db9fa514 = '#FFAB00';
var $5b2581db7ad95401$export$59619663aa6500fb = '#FF991F';
var $5b2581db7ad95401$export$874739ea9e379ab6 = '#FF8B00';
var $5b2581db7ad95401$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $5b2581db7ad95401$export$69a3bf21b9686c2b = '#ABF5D1';
var $5b2581db7ad95401$export$afbce1382ec95f73 = '#79F2C0';
var $5b2581db7ad95401$export$747d86715d4175de = '#57D9A3';
var $5b2581db7ad95401$export$940e1f69e873f202 = '#36B37E';
var $5b2581db7ad95401$export$a49394138f7b8e85 = '#00875A';
var $5b2581db7ad95401$export$6fa04827ac68a4fb = '#006644';
var $5b2581db7ad95401$export$226de0355ed012f8 = '#DEEBFF';
var $5b2581db7ad95401$export$8c13c2ee36917869 = '#B3D4FF';
var $5b2581db7ad95401$export$ecfc1dff386a3e7a = '#4C9AFF';
var $5b2581db7ad95401$export$215b7063051591f1 = '#2684FF';
var $5b2581db7ad95401$export$e62e8919cca44969 = '#0065FF';
var $5b2581db7ad95401$export$b3de0ae08da2ce64 = '#0052CC';
var $5b2581db7ad95401$export$a6ee3d71bc067634 = '#0747A6';
var $5b2581db7ad95401$export$67f15409e87642a1 = '#669DF1';
var $5b2581db7ad95401$export$f0539dbc42dbb067 = '#8FB8F6';
var $5b2581db7ad95401$export$363e4475840015bb = '#EAE6FF';
var $5b2581db7ad95401$export$4b0a4417ed59760f = '#C0B6F2';
var $5b2581db7ad95401$export$6011520a64d9a187 = '#998DD9';
var $5b2581db7ad95401$export$a7175d4e9206bc80 = '#8777D9';
var $5b2581db7ad95401$export$b48405b95304b5a1 = '#6554C0';
var $5b2581db7ad95401$export$c71e4279dd54a18d = '#5243AA';
var $5b2581db7ad95401$export$147899de772240ec = '#403294';
var $5b2581db7ad95401$export$2cf711fe14c66f06 = '#E6FCFF';
var $5b2581db7ad95401$export$7a8f4d33f6f9772c = '#B3F5FF';
var $5b2581db7ad95401$export$776c9c497ef08533 = '#79E2F2';
var $5b2581db7ad95401$export$69cb3ca10c1e330e = '#00C7E6';
var $5b2581db7ad95401$export$9dc1ef0f3f48059b = '#00B8D9';
var $5b2581db7ad95401$export$7c835c78b6fcdef8 = '#00A3BF';
var $5b2581db7ad95401$export$6036577f95c3877e = '#008DA6';
var $5b2581db7ad95401$export$29a4f05edc054374 = '#FFFFFF';
var $5b2581db7ad95401$export$e655ef011c4aa1a2 = '#FAFBFC';
var $5b2581db7ad95401$export$9fdfb749e33cdf97 = '#F4F5F7';
var $5b2581db7ad95401$export$3e51e8f1440314ba = '#EBECF0';
var $5b2581db7ad95401$export$1ce2d1575d444ceb = '#DFE1E6';
var $5b2581db7ad95401$export$8754fc7e6d8b3000 = '#C1C7D0';
var $5b2581db7ad95401$export$c2e91cbeada39b8b = '#B3BAC5';
var $5b2581db7ad95401$export$5f71e19f3a7ad9de = '#A5ADBA';
var $5b2581db7ad95401$export$eaa8c8a70ac22806 = '#97A0AF';
var $5b2581db7ad95401$export$7c87d337fb91a97d = '#8993A4';
var $5b2581db7ad95401$export$d6447c357493214f = '#7A869A';
var $5b2581db7ad95401$export$f563ee71e9ee74cd = '#6B778C';
var $5b2581db7ad95401$export$e2ef2124cf4024b1 = '#5E6C84';
var $5b2581db7ad95401$export$eece5f492e429f08 = '#505F79';
var $5b2581db7ad95401$export$c39c0fe0f26207ae = '#42526E';
var $5b2581db7ad95401$export$7090862dc3038a9f = '#344563';
var $5b2581db7ad95401$export$ad0bacf983b7ddaa = '#253858';
var $5b2581db7ad95401$export$7d61b15e0da132af = '#172B4D';
var $5b2581db7ad95401$export$fbda843f0a27fe96 = '#091E42';
var $5b2581db7ad95401$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $5b2581db7ad95401$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $5b2581db7ad95401$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $5b2581db7ad95401$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $5b2581db7ad95401$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $5b2581db7ad95401$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $5b2581db7ad95401$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $5b2581db7ad95401$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $5b2581db7ad95401$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $5b2581db7ad95401$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $5b2581db7ad95401$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $5b2581db7ad95401$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $5b2581db7ad95401$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $5b2581db7ad95401$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $5b2581db7ad95401$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $5b2581db7ad95401$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $5b2581db7ad95401$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $5b2581db7ad95401$export$2f6319cf7d736c2a = '#E6EDFA';
var $5b2581db7ad95401$export$95126bc8884d6634 = '#DCE5F5';
var $5b2581db7ad95401$export$8338d8c35d44ff1 = '#CED9EB';
var $5b2581db7ad95401$export$5368d76ae4fbbda7 = '#B8C7E0';
var $5b2581db7ad95401$export$9f0a771d16ec8d36 = '#ABBBD6';
var $5b2581db7ad95401$export$abcf8c38338b4aa5 = '#9FB0CC';
var $5b2581db7ad95401$export$97e81faa16a182c7 = '#8C9CB8';
var $5b2581db7ad95401$export$bfe21c59123ecf33 = '#7988A3';
var $5b2581db7ad95401$export$ee82aa2ea6a1558 = '#67758F';
var $5b2581db7ad95401$export$682927c6ed76be02 = '#56637A';
var $5b2581db7ad95401$export$91fd9994c5be9757 = '#455166';
var $5b2581db7ad95401$export$d281fbfe3cff2df6 = '#3B475C';
var $5b2581db7ad95401$export$3902c91d8b98a753 = '#313D52';
var $5b2581db7ad95401$export$8e8133c1ba5845b5 = '#283447';
var $5b2581db7ad95401$export$33ff357f6620b39 = '#202B3D';
var $5b2581db7ad95401$export$633847cf062b69e0 = '#1B2638';
var $5b2581db7ad95401$export$9776a6e503bdbf76 = '#121A29';
var $5b2581db7ad95401$export$6c813d5160dff5db = '#0E1624';
var $5b2581db7ad95401$export$3d4f271a500072a = '#0D1424';
var $5b2581db7ad95401$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $5b2581db7ad95401$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $5b2581db7ad95401$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $5b2581db7ad95401$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $5b2581db7ad95401$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $5b2581db7ad95401$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $5b2581db7ad95401$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $5b2581db7ad95401$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $5b2581db7ad95401$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $5b2581db7ad95401$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $5b2581db7ad95401$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $5b2581db7ad95401$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $5b2581db7ad95401$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $5b2581db7ad95401$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $5b2581db7ad95401$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $5b2581db7ad95401$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $5b2581db7ad95401$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $5b2581db7ad95401$export$d2adc5dedf09fced = '#292A2E';
var $5b2581db7ad95401$export$f51762073d2bb381 = '#94C748';
var $5b2581db7ad95401$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("7YPJK", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $5cf644e06175d7fe$export$4e9f1640bbe7a1a8; });
var $5cf644e06175d7fe$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("abrn0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $76a0299cd26dbbc7$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iQPT7 = parcelRequire("iQPT7");

var $1oC0p = parcelRequire("1oC0p");
var $76a0299cd26dbbc7$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $76a0299cd26dbbc7$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        className: (0, $iQPT7.default)([
            $76a0299cd26dbbc7$var$styles.common,
            type === 'text' && $76a0299cd26dbbc7$var$styles.text,
            type === 'icon' && $76a0299cd26dbbc7$var$styles.icon,
            isLoading && $76a0299cd26dbbc7$var$styles.fade
        ])
    }, children);
};
var $76a0299cd26dbbc7$export$2e2bcd8739ae039 = $76a0299cd26dbbc7$var$Content;

});

parcelRegister("3kkil", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26c2fb7e47c25c3e$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $39c3M = parcelRequire("39c3M");
function $26c2fb7e47c25c3e$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $26c2fb7e47c25c3e$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $26c2fb7e47c25c3e$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $39c3M.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, iconProps));
};
var $26c2fb7e47c25c3e$export$2e2bcd8739ae039 = $26c2fb7e47c25c3e$var$IconRenderer;

});


parcelRegister("iIESf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $da0c0ac94d006143$export$2e2bcd8739ae039; });
/* heading.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $2959n = parcelRequire("2959n");

var $FkQFD = parcelRequire("FkQFD");

var $7ABlR = parcelRequire("7ABlR");

var $cXplY = parcelRequire("cXplY");

var $7t0tI = parcelRequire("7t0tI");
var $da0c0ac94d006143$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $da0c0ac94d006143$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $da0c0ac94d006143$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $da0c0ac94d006143$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ var $da0c0ac94d006143$var$useColor = function useColor(colorProp) {
    var surface = (0, $7ABlR.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $FkQFD.inverseColorMap).hasOwnProperty(surface)) return (0, $FkQFD.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $da0c0ac94d006143$var$Heading = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $7t0tI;
    var _useHeading = (0, $cXplY.useHeading)($da0c0ac94d006143$var$sizeTagMap[size]), _useHeading2 = (0, $2qaZZ.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $da0c0ac94d006143$var$useColor(colorProp);
    return /*#__PURE__*/ $1oC0p.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $2959n.default)([
            $da0c0ac94d006143$var$styles.reset,
            $da0c0ac94d006143$var$headingSizeStyles[size],
            $da0c0ac94d006143$var$headingColorStyles[color]
        ])
    }, children);
});
var $da0c0ac94d006143$export$2e2bcd8739ae039 = $da0c0ac94d006143$var$Heading;

});
parcelRegister("2959n", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $19006ac139b2496a$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $19006ac139b2496a$var$ATOMIC_GROUP_LENGTH = 5;
function $19006ac139b2496a$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $19006ac139b2496a$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("FkQFD", function(module, exports) {
$parcel$export(module.exports, "inverseColorMap", function () { return $07c4008878c5efcb$export$2185ce37f9bdd963; });

var $f53LC = parcelRequire("f53LC");

var $3dJ4i = parcelRequire("3dJ4i");

var $fuJ5j = parcelRequire("fuJ5j");
function $07c4008878c5efcb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $07c4008878c5efcb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $07c4008878c5efcb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $07c4008878c5efcb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $07c4008878c5efcb$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $07c4008878c5efcb$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $07c4008878c5efcb$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $07c4008878c5efcb$export$632685d741f3dbbf = $07c4008878c5efcb$var$_objectSpread($07c4008878c5efcb$var$_objectSpread({}, $07c4008878c5efcb$export$958d0ae7f2977ae4), $07c4008878c5efcb$export$d2dc61f58390201c);
var $07c4008878c5efcb$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $07c4008878c5efcb$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $07c4008878c5efcb$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $07c4008878c5efcb$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
var $07c4008878c5efcb$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
var $07c4008878c5efcb$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #17171708)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $07c4008878c5efcb$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
var $07c4008878c5efcb$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
var $07c4008878c5efcb$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $07c4008878c5efcb$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $07c4008878c5efcb$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $07c4008878c5efcb$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // @deprecated
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $07c4008878c5efcb$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $07c4008878c5efcb$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $07c4008878c5efcb$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $07c4008878c5efcb$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $07c4008878c5efcb$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $07c4008878c5efcb$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $07c4008878c5efcb$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $f53LC.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $07c4008878c5efcb$export$e615f061ca585a6c = $07c4008878c5efcb$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $07c4008878c5efcb$export$ca0f9c2de39ffed7(spacingProperty, $07c4008878c5efcb$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $07c4008878c5efcb$export$bf46c3f9eeafc71f = $07c4008878c5efcb$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $07c4008878c5efcb$export$ca0f9c2de39ffed7(spacingProperty, $07c4008878c5efcb$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $07c4008878c5efcb$export$e7af83bafe7f9e63 = $07c4008878c5efcb$export$ca0f9c2de39ffed7('backgroundColor', $07c4008878c5efcb$export$d1d79bf68ac056bd);
var $07c4008878c5efcb$export$3a1bcba60b23d7f0 = $07c4008878c5efcb$export$ca0f9c2de39ffed7('color', $07c4008878c5efcb$export$8473307aa00d6ea1);
var $07c4008878c5efcb$export$45f3f4fe16f9f7d5 = $07c4008878c5efcb$export$ca0f9c2de39ffed7('fontWeight', $07c4008878c5efcb$export$303e322c6b1ed114);
var $07c4008878c5efcb$export$68cc305da27dbaa4 = $07c4008878c5efcb$export$ca0f9c2de39ffed7('fontFamily', $07c4008878c5efcb$export$3c7e9587132614b4);
var $07c4008878c5efcb$export$128f10c238242f83 = $07c4008878c5efcb$export$ca0f9c2de39ffed7('font', $07c4008878c5efcb$export$6ffa317d5e70375);
var $07c4008878c5efcb$export$219d364c0da35ae4 = $07c4008878c5efcb$export$ca0f9c2de39ffed7('font', $07c4008878c5efcb$export$236bfe3a33ef1292);
var $07c4008878c5efcb$export$38845ca010b93505 = $07c4008878c5efcb$export$ca0f9c2de39ffed7('fontWeight', $07c4008878c5efcb$export$855cfd311192d666);
var $07c4008878c5efcb$export$ff257d957d48c421 = $07c4008878c5efcb$export$ca0f9c2de39ffed7((0, $fuJ5j.CURRENT_SURFACE_CSS_VAR), $07c4008878c5efcb$export$41a358c9c2356760);
var $07c4008878c5efcb$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $07c4008878c5efcb$export$41a358c9c2356760[color] !== undefined;
};
var $07c4008878c5efcb$export$7001ce64d9ff7c7f = $07c4008878c5efcb$export$ca0f9c2de39ffed7('font', $07c4008878c5efcb$export$b805719bc8cb376);

});
parcelRegister("fuJ5j", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $b47ca13d4f90115c$export$9d7b58831ae93caa; });
var $b47ca13d4f90115c$export$4ef52930e33717cd = 'data-theme';
var $b47ca13d4f90115c$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $b47ca13d4f90115c$export$a00eac3f8684bcd0 = 'data-color-mode';
var $b47ca13d4f90115c$export$2112803007239c61 = 'data-contrast-mode';
var $b47ca13d4f90115c$export$352e418ed5b6193a = 'data-custom-theme';
var $b47ca13d4f90115c$export$6f0c6fb8c80fcc92 = 'ds';
var $b47ca13d4f90115c$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $b47ca13d4f90115c$export$dddac1532e822863 = "--".concat($b47ca13d4f90115c$export$6f0c6fb8c80fcc92, "-token-not-found");
var $b47ca13d4f90115c$export$9d7b58831ae93caa = "--".concat($b47ca13d4f90115c$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("7ABlR", function(module, exports) {
$parcel$export(module.exports, "useSurface", function () { return $5868de786111663c$export$1aeb4f6b93c4540d; });

var $1oC0p = parcelRequire("1oC0p");
var $5868de786111663c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $5868de786111663c$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($5868de786111663c$export$1ca2a26fecb070ae);
};
$5868de786111663c$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("cXplY", function(module, exports) {
$parcel$export(module.exports, "useHeading", function () { return $96eea9627b9bf5f7$export$97a37b1befbbf9b1; });

var $1oC0p = parcelRequire("1oC0p");
// Allows support for heading levels 1-9 via aria-level
var $96eea9627b9bf5f7$var$HeadingLevelContext = /*#__PURE__*/ (0, $1oC0p.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $96eea9627b9bf5f7$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $1oC0p.useContext)($96eea9627b9bf5f7$var$HeadingLevelContext);
};
var $96eea9627b9bf5f7$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $96eea9627b9bf5f7$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $96eea9627b9bf5f7$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $96eea9627b9bf5f7$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($96eea9627b9bf5f7$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $96eea9627b9bf5f7$export$2e2bcd8739ae039 = $96eea9627b9bf5f7$var$HeadingLevelContextProvider;

});


parcelRegister("j6lO9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de7f7e6ea7cfa158$var$_react = $de7f7e6ea7cfa158$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $de7f7e6ea7cfa158$var$_baseNew = $de7f7e6ea7cfa158$var$_interopRequireDefault((parcelRequire("20mwn")));
function $de7f7e6ea7cfa158$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de7f7e6ea7cfa158$var$CrossIcon = (props)=>/*#__PURE__*/ $de7f7e6ea7cfa158$var$_react.default.createElement($de7f7e6ea7cfa158$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$de7f7e6ea7cfa158$var$CrossIcon.displayName = 'CrossIcon';
var $de7f7e6ea7cfa158$var$_default = module.exports.default = $de7f7e6ea7cfa158$var$CrossIcon;

});
parcelRegister("20mwn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("bJFiY")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("bJFiY")).Icon; });

var $bJFiY = parcelRequire("bJFiY");

});
parcelRegister("bJFiY", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $88b3eff9e3b8958b$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $88b3eff9e3b8958b$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $anD4A = parcelRequire("anD4A");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $88b3eff9e3b8958b$var$svgStyles = null;
var $88b3eff9e3b8958b$var$iconStyles = null;
var $88b3eff9e3b8958b$var$smallIconStyles = null;
var $88b3eff9e3b8958b$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $88b3eff9e3b8958b$var$baseHcmStyles = null;
var $88b3eff9e3b8958b$var$scaleSize = null;
var $88b3eff9e3b8958b$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $88b3eff9e3b8958b$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $88b3eff9e3b8958b$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $88b3eff9e3b8958b$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $88b3eff9e3b8958b$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $anD4A.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $anD4A.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $88b3eff9e3b8958b$var$coreSizeSmall[spacing] : $88b3eff9e3b8958b$var$coreSizeMedium[spacing]
        ])
    }));
});
var $88b3eff9e3b8958b$export$2e2bcd8739ae039 = $88b3eff9e3b8958b$export$f04a61298a47a40f;

});
parcelRegister("anD4A", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $78ea5c7146102481$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $78ea5c7146102481$var$ATOMIC_GROUP_LENGTH = 5;
function $78ea5c7146102481$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $78ea5c7146102481$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("iskqs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d6faafaac1e7a72f$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $5KDhl = parcelRequire("5KDhl");

var $4u8cT = parcelRequire("4u8cT");

var $eeNLh = parcelRequire("eeNLh");
var $d6faafaac1e7a72f$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $d6faafaac1e7a72f$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $d6faafaac1e7a72f$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $5KDhl.default)([
            $d6faafaac1e7a72f$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $d6faafaac1e7a72f$var$Inline = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, $gnQ3X.default)(_ref2, $d6faafaac1e7a72f$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $1oC0p.createElement($d6faafaac1e7a72f$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1oC0p.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $1oC0p.createElement((0, $eeNLh.default), (0, $c9bqK.default)({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $4u8cT.cx)(grow === 'hug' && $d6faafaac1e7a72f$var$styles.hug, grow === 'fill' && $d6faafaac1e7a72f$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$d6faafaac1e7a72f$var$Inline.displayName = 'Inline';
var $d6faafaac1e7a72f$export$2e2bcd8739ae039 = $d6faafaac1e7a72f$var$Inline;

});
parcelRegister("5KDhl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $42ffb796a92b9bb2$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $42ffb796a92b9bb2$var$ATOMIC_GROUP_LENGTH = 5;
function $42ffb796a92b9bb2$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $42ffb796a92b9bb2$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("eeNLh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a5d8f921a5e28fd6$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $5KDhl = parcelRequire("5KDhl");
var $a5d8f921a5e28fd6$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $a5d8f921a5e28fd6$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $a5d8f921a5e28fd6$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $a5d8f921a5e28fd6$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $a5d8f921a5e28fd6$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $a5d8f921a5e28fd6$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $a5d8f921a5e28fd6$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $a5d8f921a5e28fd6$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $a5d8f921a5e28fd6$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, $gnQ3X.default)(_ref, $a5d8f921a5e28fd6$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({}, ariaAttributes, {
        role: role,
        className: (0, $5KDhl.default)([
            $a5d8f921a5e28fd6$var$styles.root,
            gap && $a5d8f921a5e28fd6$var$columnGapMap[gap],
            columnGap && $a5d8f921a5e28fd6$var$columnGapMap[columnGap],
            gap && $a5d8f921a5e28fd6$var$rowGapMap[gap],
            rowGap && $a5d8f921a5e28fd6$var$rowGapMap[rowGap],
            alignItems && $a5d8f921a5e28fd6$var$alignItemsMap[alignItems],
            direction && $a5d8f921a5e28fd6$var$flexDirectionMap[direction],
            justifyContent && $a5d8f921a5e28fd6$var$justifyContentMap[justifyContent],
            wrap && $a5d8f921a5e28fd6$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$a5d8f921a5e28fd6$var$Flex.displayName = 'Flex';
var $a5d8f921a5e28fd6$export$2e2bcd8739ae039 = $a5d8f921a5e28fd6$var$Flex;

});


parcelRegister("4Gl0I", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $368b61f1b5a1af1c$export$2e2bcd8739ae039; });
/* stack.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");


var $4u8cT = parcelRequire("4u8cT");

var $eeNLh = parcelRequire("eeNLh");
var $368b61f1b5a1af1c$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "spread",
    "grow",
    "space",
    "children",
    "testId",
    "xcss",
    "role"
];
var $368b61f1b5a1af1c$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $368b61f1b5a1af1c$var$Stack = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, ariaAttributes = (0, $gnQ3X.default)(_ref, $368b61f1b5a1af1c$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement((0, $eeNLh.default), (0, $c9bqK.default)({}, ariaAttributes, {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $4u8cT.cx)(grow === 'hug' && $368b61f1b5a1af1c$var$styles.hug, grow === 'fill' && $368b61f1b5a1af1c$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$368b61f1b5a1af1c$var$Stack.displayName = 'Stack';
var $368b61f1b5a1af1c$export$2e2bcd8739ae039 = $368b61f1b5a1af1c$var$Stack;

});

parcelRegister("5dQnj", function(module, exports) {
$parcel$export(module.exports, "getAppearanceIconStyles", function () { return $3cd6cb40d1947b7a$export$e9b82d2e21ac0c1f; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $8eIgK = parcelRequire("8eIgK");

var $fMtIj = parcelRequire("fMtIj");

var $eluGN = parcelRequire("eluGN");

var $6Ne7R = parcelRequire("6Ne7R");

var $hHPVW = parcelRequire("hHPVW");

var $RcIAF = parcelRequire("RcIAF");
function $3cd6cb40d1947b7a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3cd6cb40d1947b7a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3cd6cb40d1947b7a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3cd6cb40d1947b7a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3cd6cb40d1947b7a$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $RcIAF.B50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eluGN))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $RcIAF.B500), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $RcIAF.Y50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hHPVW))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $RcIAF.Y500), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $RcIAF.R50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fMtIj))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $RcIAF.R500), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $RcIAF.G50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ne7R))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $RcIAF.G500), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $RcIAF.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($8eIgK))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $RcIAF.P500), ")")
    }
};
function $3cd6cb40d1947b7a$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $3cd6cb40d1947b7a$var$appearanceIconSchema[appearance] || $3cd6cb40d1947b7a$var$appearanceIconSchema.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var primaryColor = _ref.primaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(appearanceIconStyles.Icon, {
            color: primaryColor,
            spacing: "spacious",
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $3cd6cb40d1947b7a$var$_objectSpread($3cd6cb40d1947b7a$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}

});
parcelRegister("8eIgK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b3613c7e18556761a1c0b5ad2c9a88f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ff1f8778af42353$var$_react = $5ff1f8778af42353$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5ff1f8778af42353$var$_baseNew = $5ff1f8778af42353$var$_interopRequireDefault((parcelRequire("20mwn")));
function $5ff1f8778af42353$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusDiscovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ff1f8778af42353$var$StatusDiscoveryIcon = (props)=>/*#__PURE__*/ $5ff1f8778af42353$var$_react.default.createElement($5ff1f8778af42353$var$_baseNew.default, Object.assign({
        name: "StatusDiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.5 15.06v-3.81a.75.75 0 0 1 .75-.75h3.81z"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v6h-4.75C9.56 9 9 9.56 9 10.25V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM4 9h3V7.5H4zm0-5v1.5h7V4z" clip-rule="evenodd"/>`
    }, props));
$5ff1f8778af42353$var$StatusDiscoveryIcon.displayName = 'StatusDiscoveryIcon';
var $5ff1f8778af42353$var$_default = module.exports.default = $5ff1f8778af42353$var$StatusDiscoveryIcon;

});

parcelRegister("fMtIj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b7d2633ac0924260$var$_react = $b7d2633ac0924260$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b7d2633ac0924260$var$_baseNew = $b7d2633ac0924260$var$_interopRequireDefault((parcelRequire("20mwn")));
function $b7d2633ac0924260$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b7d2633ac0924260$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $b7d2633ac0924260$var$_react.default.createElement($b7d2633ac0924260$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$b7d2633ac0924260$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $b7d2633ac0924260$var$_default = module.exports.default = $b7d2633ac0924260$var$StatusErrorIcon;

});

parcelRegister("eluGN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a71ad51b5a54e535$var$_react = $a71ad51b5a54e535$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a71ad51b5a54e535$var$_baseNew = $a71ad51b5a54e535$var$_interopRequireDefault((parcelRequire("20mwn")));
function $a71ad51b5a54e535$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a71ad51b5a54e535$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $a71ad51b5a54e535$var$_react.default.createElement($a71ad51b5a54e535$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$a71ad51b5a54e535$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $a71ad51b5a54e535$var$_default = module.exports.default = $a71ad51b5a54e535$var$StatusInformationIcon;

});

parcelRegister("6Ne7R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f2246c27b136572$var$_react = $4f2246c27b136572$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4f2246c27b136572$var$_baseNew = $4f2246c27b136572$var$_interopRequireDefault((parcelRequire("20mwn")));
function $4f2246c27b136572$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f2246c27b136572$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $4f2246c27b136572$var$_react.default.createElement($4f2246c27b136572$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$4f2246c27b136572$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $4f2246c27b136572$var$_default = module.exports.default = $4f2246c27b136572$var$StatusSuccessIcon;

});

parcelRegister("hHPVW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce3ebcbc01eccf5f$var$_react = $ce3ebcbc01eccf5f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ce3ebcbc01eccf5f$var$_baseNew = $ce3ebcbc01eccf5f$var$_interopRequireDefault((parcelRequire("20mwn")));
function $ce3ebcbc01eccf5f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce3ebcbc01eccf5f$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $ce3ebcbc01eccf5f$var$_react.default.createElement($ce3ebcbc01eccf5f$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$ce3ebcbc01eccf5f$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $ce3ebcbc01eccf5f$var$_default = module.exports.default = $ce3ebcbc01eccf5f$var$StatusWarningIcon;

});

parcelRegister("RcIAF", function(module, exports) {
$parcel$export(module.exports, "R50", function () { return $09fed0ebdaed054b$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R500", function () { return $09fed0ebdaed054b$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $09fed0ebdaed054b$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y500", function () { return $09fed0ebdaed054b$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $09fed0ebdaed054b$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G500", function () { return $09fed0ebdaed054b$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $09fed0ebdaed054b$export$226de0355ed012f8; });
$parcel$export(module.exports, "B500", function () { return $09fed0ebdaed054b$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "P50", function () { return $09fed0ebdaed054b$export$363e4475840015bb; });
$parcel$export(module.exports, "P500", function () { return $09fed0ebdaed054b$export$147899de772240ec; });
// Reds
var $09fed0ebdaed054b$export$4b84fd0e2c617bd = '#FFEBE6';
var $09fed0ebdaed054b$export$b34b069eff244586 = '#FFBDAD';
var $09fed0ebdaed054b$export$be802dd0d8b57f35 = '#FF8F73';
var $09fed0ebdaed054b$export$60847d42f9da92a6 = '#FF7452';
var $09fed0ebdaed054b$export$4a7404f376229999 = '#FF5630';
var $09fed0ebdaed054b$export$2010d0fb4295b346 = '#DE350B';
var $09fed0ebdaed054b$export$2837b5a1a71d5c02 = '#BF2600';
var $09fed0ebdaed054b$export$8d9596b529bbb9cf = '#FFFAE6';
var $09fed0ebdaed054b$export$41060a744ab0b7ae = '#FFF0B3';
var $09fed0ebdaed054b$export$1cc05bbbf340e559 = '#FFE380';
var $09fed0ebdaed054b$export$5aae31392d72caaa = '#FFC400';
var $09fed0ebdaed054b$export$c6930421db9fa514 = '#FFAB00';
var $09fed0ebdaed054b$export$59619663aa6500fb = '#FF991F';
var $09fed0ebdaed054b$export$874739ea9e379ab6 = '#FF8B00';
var $09fed0ebdaed054b$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $09fed0ebdaed054b$export$69a3bf21b9686c2b = '#ABF5D1';
var $09fed0ebdaed054b$export$afbce1382ec95f73 = '#79F2C0';
var $09fed0ebdaed054b$export$747d86715d4175de = '#57D9A3';
var $09fed0ebdaed054b$export$940e1f69e873f202 = '#36B37E';
var $09fed0ebdaed054b$export$a49394138f7b8e85 = '#00875A';
var $09fed0ebdaed054b$export$6fa04827ac68a4fb = '#006644';
var $09fed0ebdaed054b$export$226de0355ed012f8 = '#DEEBFF';
var $09fed0ebdaed054b$export$8c13c2ee36917869 = '#B3D4FF';
var $09fed0ebdaed054b$export$ecfc1dff386a3e7a = '#4C9AFF';
var $09fed0ebdaed054b$export$215b7063051591f1 = '#2684FF';
var $09fed0ebdaed054b$export$e62e8919cca44969 = '#0065FF';
var $09fed0ebdaed054b$export$b3de0ae08da2ce64 = '#0052CC';
var $09fed0ebdaed054b$export$a6ee3d71bc067634 = '#0747A6';
var $09fed0ebdaed054b$export$67f15409e87642a1 = '#669DF1';
var $09fed0ebdaed054b$export$f0539dbc42dbb067 = '#8FB8F6';
var $09fed0ebdaed054b$export$363e4475840015bb = '#EAE6FF';
var $09fed0ebdaed054b$export$4b0a4417ed59760f = '#C0B6F2';
var $09fed0ebdaed054b$export$6011520a64d9a187 = '#998DD9';
var $09fed0ebdaed054b$export$a7175d4e9206bc80 = '#8777D9';
var $09fed0ebdaed054b$export$b48405b95304b5a1 = '#6554C0';
var $09fed0ebdaed054b$export$c71e4279dd54a18d = '#5243AA';
var $09fed0ebdaed054b$export$147899de772240ec = '#403294';
var $09fed0ebdaed054b$export$2cf711fe14c66f06 = '#E6FCFF';
var $09fed0ebdaed054b$export$7a8f4d33f6f9772c = '#B3F5FF';
var $09fed0ebdaed054b$export$776c9c497ef08533 = '#79E2F2';
var $09fed0ebdaed054b$export$69cb3ca10c1e330e = '#00C7E6';
var $09fed0ebdaed054b$export$9dc1ef0f3f48059b = '#00B8D9';
var $09fed0ebdaed054b$export$7c835c78b6fcdef8 = '#00A3BF';
var $09fed0ebdaed054b$export$6036577f95c3877e = '#008DA6';
var $09fed0ebdaed054b$export$29a4f05edc054374 = '#FFFFFF';
var $09fed0ebdaed054b$export$e655ef011c4aa1a2 = '#FAFBFC';
var $09fed0ebdaed054b$export$9fdfb749e33cdf97 = '#F4F5F7';
var $09fed0ebdaed054b$export$3e51e8f1440314ba = '#EBECF0';
var $09fed0ebdaed054b$export$1ce2d1575d444ceb = '#DFE1E6';
var $09fed0ebdaed054b$export$8754fc7e6d8b3000 = '#C1C7D0';
var $09fed0ebdaed054b$export$c2e91cbeada39b8b = '#B3BAC5';
var $09fed0ebdaed054b$export$5f71e19f3a7ad9de = '#A5ADBA';
var $09fed0ebdaed054b$export$eaa8c8a70ac22806 = '#97A0AF';
var $09fed0ebdaed054b$export$7c87d337fb91a97d = '#8993A4';
var $09fed0ebdaed054b$export$d6447c357493214f = '#7A869A';
var $09fed0ebdaed054b$export$f563ee71e9ee74cd = '#6B778C';
var $09fed0ebdaed054b$export$e2ef2124cf4024b1 = '#5E6C84';
var $09fed0ebdaed054b$export$eece5f492e429f08 = '#505F79';
var $09fed0ebdaed054b$export$c39c0fe0f26207ae = '#42526E';
var $09fed0ebdaed054b$export$7090862dc3038a9f = '#344563';
var $09fed0ebdaed054b$export$ad0bacf983b7ddaa = '#253858';
var $09fed0ebdaed054b$export$7d61b15e0da132af = '#172B4D';
var $09fed0ebdaed054b$export$fbda843f0a27fe96 = '#091E42';
var $09fed0ebdaed054b$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $09fed0ebdaed054b$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $09fed0ebdaed054b$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $09fed0ebdaed054b$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $09fed0ebdaed054b$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $09fed0ebdaed054b$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $09fed0ebdaed054b$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $09fed0ebdaed054b$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $09fed0ebdaed054b$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $09fed0ebdaed054b$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $09fed0ebdaed054b$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $09fed0ebdaed054b$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $09fed0ebdaed054b$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $09fed0ebdaed054b$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $09fed0ebdaed054b$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $09fed0ebdaed054b$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $09fed0ebdaed054b$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $09fed0ebdaed054b$export$2f6319cf7d736c2a = '#E6EDFA';
var $09fed0ebdaed054b$export$95126bc8884d6634 = '#DCE5F5';
var $09fed0ebdaed054b$export$8338d8c35d44ff1 = '#CED9EB';
var $09fed0ebdaed054b$export$5368d76ae4fbbda7 = '#B8C7E0';
var $09fed0ebdaed054b$export$9f0a771d16ec8d36 = '#ABBBD6';
var $09fed0ebdaed054b$export$abcf8c38338b4aa5 = '#9FB0CC';
var $09fed0ebdaed054b$export$97e81faa16a182c7 = '#8C9CB8';
var $09fed0ebdaed054b$export$bfe21c59123ecf33 = '#7988A3';
var $09fed0ebdaed054b$export$ee82aa2ea6a1558 = '#67758F';
var $09fed0ebdaed054b$export$682927c6ed76be02 = '#56637A';
var $09fed0ebdaed054b$export$91fd9994c5be9757 = '#455166';
var $09fed0ebdaed054b$export$d281fbfe3cff2df6 = '#3B475C';
var $09fed0ebdaed054b$export$3902c91d8b98a753 = '#313D52';
var $09fed0ebdaed054b$export$8e8133c1ba5845b5 = '#283447';
var $09fed0ebdaed054b$export$33ff357f6620b39 = '#202B3D';
var $09fed0ebdaed054b$export$633847cf062b69e0 = '#1B2638';
var $09fed0ebdaed054b$export$9776a6e503bdbf76 = '#121A29';
var $09fed0ebdaed054b$export$6c813d5160dff5db = '#0E1624';
var $09fed0ebdaed054b$export$3d4f271a500072a = '#0D1424';
var $09fed0ebdaed054b$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $09fed0ebdaed054b$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $09fed0ebdaed054b$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $09fed0ebdaed054b$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $09fed0ebdaed054b$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $09fed0ebdaed054b$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $09fed0ebdaed054b$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $09fed0ebdaed054b$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $09fed0ebdaed054b$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $09fed0ebdaed054b$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $09fed0ebdaed054b$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $09fed0ebdaed054b$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $09fed0ebdaed054b$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $09fed0ebdaed054b$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $09fed0ebdaed054b$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $09fed0ebdaed054b$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $09fed0ebdaed054b$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $09fed0ebdaed054b$export$d2adc5dedf09fced = '#292A2E';
var $09fed0ebdaed054b$export$f51762073d2bb381 = '#94C748';
var $09fed0ebdaed054b$export$95e26d54def96891 = '#B3DF72';

});




//# sourceMappingURL=direct-buy-site-setup-container.851f1d91.js.map
